import {
  hasFullPlatform,
  isFreeSupplier,
  isFreeSupplierPlan,
  SUPPLIER_HOME_PATH,
} from '../FreeSupplier/planAccess';

export const destinationForPermissions = (permissions) => {
  if (isFreeSupplier(permissions)) return SUPPLIER_HOME_PATH;
  if (isFreeSupplierPlan(permissions) || !hasFullPlatform(permissions)) {
    throw new Error('The workspace plan is not ready yet.');
  }
  return '/operator-overview';
};

/**
 * Is this workspace on a free-tier plan WITHOUT the Journey entitlement?
 *
 * There is no landing page such a workspace is allowed to reach. InitPage used
 * to express that as `url = '/not-found'` followed by a history.replace — an
 * irreversible navigation, so a plan that resolved a beat later stranded the
 * user on the 404. It is a DENIAL and now renders in place.
 *
 * Extracted from InitPage so the predicate is testable on its own: InitPage
 * itself needs Clerk, onboarding, freemium and trial context to mount, which is
 * exactly the kind of cost that leaves a security decision untested.
 *
 * `redirectUrl` wins over everything — an explicit post-auth destination is not
 * a plan decision. Callers must only consult this with a SETTLED `me`; an
 * unresolved payload is not a denial.
 * See docs/features/denial-never-navigates/00-OVERVIEW.md (N1, site 7).
 */
export const isPlanDenied = ({ me, redirectUrl }) =>
  !redirectUrl && !isFreeSupplier(me) && isFreeSupplierPlan(me);
